import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHackclubComponent } from './simple-icons-hackclub.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHackclubComponent ],
    exports:      [ SimpleIconsHackclubComponent ],
    bootstrap:    []
})
export class SimpleIconsHackclubModule {}
